<forge-card appearance="outlined" [formGroup]="formGroup" class="chart"
    telemetry="Card-PrepaidConsumptionChart-UtilityBilling" no-padding>
    <forge-toolbar fxLayout="column">
        <h2 slot="start" class="forge-typography--heading4">Prepaid Consumption</h2>

        @if (isLoaded) {
        <lgd-select slot="center" fxFlex="40" controlName="serviceType" label="Service"
            [options]="serviceTypesObservable" [suppressSupportText]="true" style="width: 60%;">
        </lgd-select>
        }

        <forge-icon-button slot="end" (click)="displayChartParameterDialogAndReload()" tabindex="0"
            telemetry="Chart settings" aria-label="chart settings">
            <forge-tooltip position="bottom">Chart settings</forge-tooltip>
            <forge-icon name="settings"></forge-icon>
        </forge-icon-button>
    </forge-toolbar>

    <div class="metadata-padding">
        @if (isLoaded) {
        <div fxLayoutAlign="center stretch">
            @if (showChart()) {
            <chartjs-container [config]="chartConfig">
            </chartjs-container>
            }
            @if (!chartHasData && !errorMessage) {
            <div>
                Not enough data to display graph
            </div>
            }
            @if (errorMessage) {
            <div class="error-red">
                {{errorMessage}}
            </div>
            }
        </div>
        }
        @else {
        <busy-indicator [chart]="true"></busy-indicator>
        }
    </div>
</forge-card>